import axios from 'axios';
import * as types from '../constants/ActionTypes';

const searchURL = '/smarthelp/related-article';
const defaultTopReasonQuery = 'HELPHUB_TOPCONTACTREASON';
const defaultSize = 5;

const defaultSearchEnable = () => ({ type: types.DEFAULT_SEARCH_ENABLE });

const setDefaultTopSearchReason = response => ({
  type: types.DEFAULT_TOP_SEARCH_REASON,
  payload: response,
});

const defaultTopSearchError = () => ({ type: types.DEFAULT_TOP_SEARCH_REASON_ERROR });

// Filter top contact reason response data
const filterSearchResponse = (responseData) => {
  if (!Array.isArray(responseData)) {
    return [];
  }

  return responseData.slice(0, defaultSize)
    .map(article => ({
      title: article.articleTitle,
      docid: article.articleId,
    }));
};

// Get top contact Reason as default search selection
const getTopSearchReason = () => dispatch => (
  axios(`${searchURL}?topic=${defaultTopReasonQuery}`)
    .then((res) => {
      dispatch(setDefaultTopSearchReason(filterSearchResponse(res.data)));
    })
    .catch(() => {
      dispatch(defaultTopSearchError());
    })
);
// SHOW_TOP_CONTACT_REASON showing the faqs
const showTopReason = () => ({ type: types.SHOW_TOP_CONTACT_REASON });

const hideTopReason = () => ({ type: types.HIDE_TOP_CONTACT_REASON });

module.exports = {
  defaultSearchEnable,
  getTopSearchReason,
  showTopReason,
  hideTopReason,
};
